import { api } from "../../services/users.service";
import { UserData } from "../../types/documents";
import { useQuery } from "./useQuery";

export const useUsers = () => useQuery<UserData>([], "users", api.query);
